import React from 'react';
import ZodiacWheel from '../UI/ZodiacWheel';
import './PageHeader.css';

/**
 * En-tête de page façon landing : panneau ciel nocturne, étoiles,
 * roue zodiacale animée, eyebrow doré + titre + sous-titre.
 */
const PageHeader = ({ eyebrow, title, subtitle, children }) => {
    return (
        <header className="page-header sky">
            <ZodiacWheel className="page-header-wheel" />
            <div className="page-header-content">
                {eyebrow && (
                    <p className="page-header-eyebrow rise rise-1">
                        <span className="star-accent">✦</span> {eyebrow}
                    </p>
                )}
                <h1 className="rise rise-2">{title}</h1>
                {subtitle && <p className="page-header-subtitle rise rise-3">{subtitle}</p>}
                {children && <div className="page-header-extra rise rise-4">{children}</div>}
            </div>
        </header>
    );
};

export default PageHeader;
